import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getFeaturedSubscriptionPlan } from '../../../../store/slices/paymentsSlice';
import PaymentButton, { paymentBtnType } from '../../../common/PaymentButton';
import styles from '../styles.module.scss';

const IssuePaymentContent = () => {
    const { t } = useTranslation();
    const plan = useSelector(getFeaturedSubscriptionPlan);
    const planDays = plan?.period?.days;
    const planPrice = plan?.price;
    const price = planPrice?.currency?.symbol + planPrice?.value || '';
    const date = DateTime.now().toFormat('LLLL d');

    return (
        <>
            <h2 className={styles.title}>{t('pages.payment.title3')}</h2>
            <p className={styles.text}>{t('pages.payment.label3')}</p>
            <PaymentButton text={t('buttons.retry')} type={paymentBtnType.subscription} googleEvent={'chatPopup'} source={'paymentRetry'} />
            <p className={styles.price}>{t('pages.payment.priceOn', { price, date, planDays })}</p>
        </>
    );
};

export default IssuePaymentContent;
